import React from "react";

/**
 * CARTHY brand logo — cube picto + wordmark.
 *
 * Props:
 *   size:    height of the logo in px (default 32). The cube stays square,
 *            the wordmark scales proportionally.
 *   variant: "full" (picto + wordmark) | "picto" (only cube)
 *   className
 */
const Logo = ({ size = 32, variant = "full", className = "", testid = "carthy-logo" }) => {
  const cubeStyle = { height: size, width: size };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-3 group select-none ${className}`}
    >
      <img
        src="/brand/carthy-cube.png"
        alt="CARTHY"
        style={cubeStyle}
        className="object-contain drop-shadow-[0_0_18px_rgba(118,185,0,0.55)] transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3"
      />
      {variant === "full" && (
        <img
          src="/brand/carthy-wordmark.png"
          alt="CARTHY"
          style={{ height: Math.round(size * 0.62) }}
          className="object-contain"
        />
      )}
    </span>
  );
};

export default Logo;
